<template>
  <v-navigation-drawer
    v-if="asyncDataStatus_ready"
    app
    clipped
    v-model="DRAWER_STATE"
    :mini-variant="!DRAWER_STATE"
    :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.lgAndUp"
    :temporary="$vuetify.breakpoint.mdAndDown"
    :mini-variant-width="sidebarMinWidth"
    :class="{ 'drawer-mini': !DRAWER_STATE }"
  >
    <v-list>
      <template v-for="(item, i) in items">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <span
              style="padding-left: 32px"
              class="text-body-1 subheader"
              :class="item.heading && DRAWER_STATE ? 'show ' : 'hide'"
            >
              {{ item.heading }}
            </span>
          </v-col>
          <v-col cols="6" class="text-center"> </v-col>
        </v-row>
        <v-divider
          v-else-if="item.divider"
          :key="i"
          dark
          class="my-4"
        ></v-divider>
        <v-list-group
          color="primary"
          v-else-if="item.children && DRAWER_STATE"
          :key="item.title"
          v-model="item.model"
        >
          <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0" color="greyTint">
              {{ item.icon }}
            </v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-content>
              <v-badge v-if="item.badge" content="New" color="secondary">
              </v-badge>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-show="!item.type"
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.link"
            link
            class="pl-12"
            @click="child.action ? child.action() : null"
          >
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon size="">{{ child.icon }}</v-icon>
            </v-list-item-action>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-list-tile-content v-on="on">
                  <v-list-item-title>
                    {{ child.title }}
                  </v-list-item-title>
                </v-list-tile-content>
              </template>
              <span>{{ child.description }}</span>
            </v-tooltip>
          </v-list-item>

          <template v-if="item.type">
            {{item.type}}
            <v-list-group
              v-for="(item, i) in item.children"
              :key="i"
              :value="true"
              no-action
              sub-group
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <template v-for="(child, i) in item.children">
                <v-tooltip right :key="i">
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      :to="child.link"
                      link
                      @click="child.action ? child.action() : null"
                      v-on="on"
                    >
                      <v-list-tile-content>
                        <v-list-item-title>
                          {{ child.title }}
                        </v-list-item-title>
                      </v-list-tile-content>
                    </v-list-item>
                  </template>
                  <span> {{ child.description }} </span>
                </v-tooltip>
              </template>
            </v-list-group>
          </template>
        </v-list-group>
        <v-list-item
          color="primary"
          v-else
          :key="item.text"
          :href="item.href ? item.href : null"
          :to="item.link === '#' ? '' : item.link"
          @click="item.action ? item.action() : null"
          link
        >
          <v-list-item-action class="mr-6">
            <v-icon
              :size="item.size ? item.size : 24"
              :color="item.color ? item.color : 'greyTint'"
              >{{ item.icon }}</v-icon
            >
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title link>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
        <v-list-item
          v-if="!hasPapelFinanciador"
          color="primary"
          key="contas"
          :to="{name: 'Contas', params: {projetoId: this.$route.params.projetoId}}"
          @click="item.action ? item.action() : null"
          link
        >
          <v-list-item-action class="mr-6">
            <v-icon
              size="24"
              color="greyTint"
              >mdi-finance</v-icon
            >
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title link>
              Prestação de Contas
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  props: {
    source: String,
  },
  data() {
    return {
      items: [
        { title: "Início", icon: "mdi-home", link: "/inicio" },
        { title: "Dashboard", icon: "mdi-view-dashboard", link: {name: 'Dashboard', params: {projetoId: this.$route.params.projetoId}}},
        { title: "Projeto", icon: "mdi-briefcase", link: {name: 'Projeto', params: {projetoId: this.$route.params.projetoId}}},
        { title: "Matriz", icon: "mdi-table-large", link: {name: 'Matriz', params: {projetoId: this.$route.params.projetoId}} },
        { title: 'Pessoas Alcançadas', icon: 'mdi-account-group', link: {name: 'PessoasAlcancadas', params: {projetoId: this.$route.params.projetoId}} },
      ],
      chatItems: [
        {
          avatar: require("@/assets/img/time-line/a1.jpg"),
          title: "Jane Hew",
          subtitle: "<span>Hey! How it's going?</span>",
        },
        {
          avatar: require("@/assets/img/time-line/a2.jpg"),
          title: "Axel Pittman",
          subtitle:
            "<span class='text--primary'>I'll definitely buy this template</span>",
        },
        {
          avatar: require("@/assets/img/time-line/a3.jpg"),
          title: "Sophia Fernandez",
          subtitle:
            "<span class='text--primary'>What's the font-family?</span>",
        },
      ],
      sidebarWidth: 240,
      sidebarMinWidth: 96,
      dialog: false,
      chat: false,
      chatMessage: "",
    };
  },
  computed: {
    ...mapState("layout", {
      drawer: (state) => state.drawer,
    }),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
      set(newValue) {
        if (newValue === this.drawer) return;
        this.TOGGLE_DRAWER();
      },
    },

    hasPapelFinanciador() {
      var payload = {
        'papel': 'FINANCIADOR',
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }
      return this.$store.getters["projeto/hasPapel"](payload);
    }

  },
  mixins: [asyncDataStatus],
  methods: {
    ...mapActions("layout", ["TOGGLE_DRAWER"]),
    ...mapActions('usuario', ['getUsuario']),

    logOut: function () {
      window.localStorage.setItem("authenticated", false);
      window.localStorage.removeItem("token");
      this.$router.push("/login");
    },
    addSection: function () {
      this.dialog = true;
    },
    newMessage: function () {
      let post = {
        avatar: require("@/assets/img/user/avatars/avatar.png"),
        title: "John Smith",
        subtitle: "",
      };
      if (this.chatMessage.length !== 0) {
        post.subtitle = this.chatMessage;
        this.chatItems.push(post);
        this.chatMessage = "";
      }
    },
    getLink(link) {
      link.replace(new RegExp("{projetoId}", "g"), this.$route.params.projetoId)
    }
  },
  created () {
    this.getUsuario()
      .then(() => { this.asyncDataStatus_fetched() })
  }  

};
</script>


<style src="./ProjetoSidebar.scss" lang="scss"/>
